export const userSkills = ["HTML", "SCSS", "JS", "REACT"];

export const userContacts = [
  {
    key: "mail",
    idIcon: "icon-mail",
    width: 14,
    height: 12,
    label: "vays3btro@gmail.com",
    link: "mailto:vays3btro@gmail.com"
  },
  {
    key: "point",
    idIcon: "icon-phone",
    width: 12,
    height: 12,
    label: "+7(949) 432-73-99",
    link: "tel:79494327399"
  },
  {
    key: "site",
    idIcon: "icon-link",
    width: 14,
    height: 14,
    label: "artCode.dev",
    link: "https://artCode-dev.vercel.app"
  },
]